import React, { Component } from 'react';
import ReadyButton from 'components/ReadyButton';
import AudioPlayer from 'components/AudioPlayer';
import strings from 'strings';

import no_sm_intro from 'assets/sounds/no/intros/setningsminne-intro.mp3';
import nn_sm_intro from 'assets/sounds/nn/intros/setningsminne-intro.mp3';

class IntroSentences extends Component {
  constructor(props) {
    super(props);
    this.audio = strings.getLanguage() === 'nn' ? nn_sm_intro : no_sm_intro;
  }
  render() {
    return (
      <>
        <p>
          <AudioPlayer autoplay inline src={this.audio} />
          {strings.sm_intro1}<br />
          {strings.sm_intro2}
        </p>
      </>
    );
  }
}
export default IntroSentences;
